import type { SessionDetail } from '~/gql/sessions/sessions'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'
import { tourAnchor } from '~/helpers/tour/anchors'
import { userDisplayName } from '~/helpers/users/display-name'

type IProps = {
  trainers: SessionDetail['trainers']
}

/** Qui anime la session (#244) : nom, rôle et adresse de chaque formateur. */
function SessionTrainersCard({ trainers }: IProps) {
  const { t } = useTranslation()
  const titleId = useId()

  return (
    <Card role="region" aria-labelledby={titleId} {...tourAnchor('sessionDetail.trainers')}>
      <CardHeader>
        <CardTitle id={titleId} className="text-lg">{t('sessions.trainers.label')}</CardTitle>
      </CardHeader>
      <CardContent>
        {trainers.length === 0
          ? <p className="text-sm text-muted-foreground">{t('sessionDetail.trainers.empty')}</p>
          : (
              <ul className="flex flex-col gap-3">
                {trainers.map(trainer => (
                  <li key={trainer.id} className="flex flex-col gap-0.5">
                    <span className="font-medium">{userDisplayName(trainer)}</span>
                    <span className="text-sm text-muted-foreground">{t(`role.${trainer.role}`, { defaultValue: trainer.role })}</span>
                    {trainer.email && <a href={`mailto:${trainer.email}`} className="text-sm text-muted-foreground underline-offset-4 hover:underline">{trainer.email}</a>}
                  </li>
                ))}
              </ul>
            )}
      </CardContent>
    </Card>
  )
}

export default SessionTrainersCard
